// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { InformationBox } from '../../../../../organisms/information-box';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { type Country } from '@tectonics/prs/country';
import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';
import {SafetyPayBankIcons} from '../../safetypay-bank-icons';

export function SafetypayCashInfo(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  const allFeatures = useAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_cash_instructions">
        <SafetypayCashInfoByCountry country={country} />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_cash_banks">
        <SafetyPayBankIcons />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_cash_other_methods_tip">
        <InformationBox>
          En caso de no poder realizar tu pago con el método que elegiste,
          tendrás siempre la opción de generar un nuevo pedido y pagar con Transferencia.
        </InformationBox>
      </IfFeature>
    </>
  );
}

type Props = {
  country: Country;
};

function SafetypayCashInfoByCountry({ country }: Props): Node {
  switch (country) {
    case 'pe':
      return (
        <InformationBox>
          Locales de pago disponibles: <strong>BCP, BBVA, Interbank, Scotiabank, Caja
          Arequipa, Caja Tacna, Caja Trujillo, TAMBO, Western Union, Banco Ripley</strong> y <strong>Caja Huancayo</strong>.
          <Separator direction="vertical" size={3} />
          Recuerda que tienes hasta 72 horas para realizar tu pago.
        </InformationBox>
      );
    case 'ec':
      return (
        <p>
          Una vez que generes tu código de pago en efectivo, tendrás 72 hrs para realizar tu pago en las siguientes opciones:
        </p>
      );
    default:
      return '';
  }
}
